<template>
  <vue-simplebar id="sign-up" class="panel">
    <h3
      class="font-mdish wt-md align-center"
      style="margin-bottom: 0px"
      v-if="!inline"
    >
      New to A Perfect Space?
    </h3>
    <h4 class="align-center">Let us know a bit about you.</h4>
    <form method="post" @submit.prevent="signup" id="join-form-gtm">
      <div
        class="form-group vanilla no-top-margin"
        :class="{ 'has-input-error': errors.type }"
      >
        <label>I want to <span class="required">*</span></label>
        <select-wrapper
          id="sign-up-type"
          name="sign-up-type"
          :options="signupTypeOptions"
          v-model="account.type"
        ></select-wrapper>
        <input-error v-if="errors.type">
          {{ errors.type[0] }}
        </input-error>
      </div>
      <div class="form-section columned two-column unlined">
        <div
          class="form-group vanilla"
          :class="{ 'has-input-error': errors.first_name }"
        >
          <label for="sign-up-first-name"
            >First name <span class="required">*</span></label
          >
          <input
            id="sign-up-first-name"
            type="text"
            name="first_name"
            v-model="account.first_name"
            required
          />
          <input-error v-if="errors.first_name">
            {{ errors.first_name[0] }}
          </input-error>
        </div>
        <div
          class="form-group vanilla"
          :class="{ 'has-input-error': errors.last_name }"
        >
          <label for="sign-up-last-name"
            >Last name <span class="required">*</span></label
          >
          <input
            id="sign-up-last-name"
            type="text"
            name="last_name"
            v-model="account.last_name"
            required
          />
          <input-error v-if="errors.last_name">
            {{ errors.last_name[0] }}
          </input-error>
        </div>
      </div>
      <div
        class="form-group vanilla"
        :class="{ 'has-input-error': errors.email }"
      >
        <label for="sign-up-email">Email <span class="required">*</span></label>
        <input
          id="sign-up-email"
          type="email"
          name="email"
          v-model="account.email"
          required
        />
        <input-error v-if="errors.email">
          {{ errors.email[0] }}
        </input-error>
      </div>
      <div
        class="form-group vanilla"
        :class="{ 'has-input-error': errors.phone }"
      >
        <label for="sign-up-phone">Phone <span class="required">*</span></label>
        <input
          id="sign-up-phone"
          type="text"
          name="phone"
          v-model="account.phone"
          required
        />
        <input-error v-if="errors.phone">
          {{ errors.phone[0] }}
        </input-error>
      </div>
      <div class="form-section columned two-column unlined">
        <div
          class="form-group vanilla"
          :class="{ 'has-input-error': errors.password }"
        >
          <label for="sign-up-password"
            >Password <span class="required">*</span></label
          >
          <input
            id="sign-up-password"
            type="password"
            name="password"
            v-model="account.password"
            required
          />
          <input-error v-if="errors.password">
            {{ errors.password[0] }}
          </input-error>
        </div>
        <div class="form-group vanilla">
          <label for="sign-up-confirm-password"
            >Confirm password <span class="required">*</span></label
          >
          <input
            id="sign-up-confirm-password"
            type="password"
            name="confirm_password"
            v-model="account.password_confirmation"
            required
          />
        </div>
      </div>
      <checkbox
        class="form-group"
        :class="{ 'has-input-error': errors.terms_agree }"
        label="I agree to the <a href='/terms-and-conditions' target='blank'>terms &amp; conditions</a>, <a href='/privacy-policy' target='blank'>privacy policy</a> and <a href='/terms-and-conditions/hirer' target='blank'>hirer terms &amp; conditions</a><span class='required'>*</span>"
        :required="true"
        required-message="Please agree to our policies to continue."
        v-model="account.terms_agree"
        v-if="account.type !== 'lister'"
        @click.native="handleTermsClick"
      ></checkbox>
      <checkbox
        class="form-group"
        :class="{ 'has-input-error': errors.terms_agree }"
        label="I agree to the <a href='/terms-and-conditions' target='blank'>terms &amp; conditions</a>, <a href='/privacy-policy' target='blank'>privacy policy</a> and <a href='/terms-and-conditions/lister' target='blank'>lister terms &amp; conditions</a>"
        :required="true"
        required-message="Please agree to our policies to continue."
        v-model="account.terms_agree"
        v-if="account.type === 'lister'"
        @click.native="handleTermsClick"
      ></checkbox>
      <input-error v-if="errors.terms_agree">
        {{ errors.terms_agree[0] }}
      </input-error>
      <div class="form-group vanilla submit">
        <loader-button
          type="submit"
          :loading="loading"
          label="Join"
          class="primary block join-btn-gtm"
        ></loader-button>
      </div>
    </form>

    <social-login-buttons></social-login-buttons>
  </vue-simplebar>
</template>

<script>
import SocialLoginButtons from "./shared/SocialLoginButtons";

export default {
  components: {
    SocialLoginButtons,
  },
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.loading = true;
    axios
      .get("/api/form-meta/sign-up")
      .then((response) => (this.meta = response.data))
      .catch(() => {})
      .then(() => (this.loading = false));
  },
  data() {
    return {
      account: this.accountState(),
      loading: false,
      errors: [],
      notice: "",
      disabled: false,
      disable_business_input: false,
      business_input_loading: false,
    };
  },
  computed: {
    signupTypeOptions() {
      return [
        { id: "", label: "Please select" },
        { id: "hirer", label: "Hire a space" },
        { id: "lister", label: "List a space" },
      ];
    },
  },
  methods: {
    accountState() {
      return {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        type: "",
        password: "",
        password_confirmation: "",
        subscribe: false,
        terms_agree: false,
        pageUri: "",
        pageName: "",
      };
    },
    preSignup() {
      if (this.account.type == "lister") {
        this.$store
          .dispatch("modals/show", {
            title: `Welcome ${this.account.first_name} !`,
            cancelLabel: "Cancel",
            confirmLabel: "Ok",
            confirmMessage: `<div class="box">
          <p> Thank you for joining us and completing the first part of your profile.</p> <br>
          <h3><strong>Next Step - Set your payment details</strong></h3>

        <p>Before you get to the fun part - listing your unique space - we need to confirm your details and make sure we
            can pay you. We use Stripe as our secure payment gateway. You’ll need to set up a Stripe account, and to do
            so
            you’ll be redirected to the Stripe site. Once you’re all set up, you’ll be redirected back to us to start
            listing!</p> <br>

        <h3><strong>What is Stripe?</strong></h3>
        <p> Stripe is an online credit card provider that has been audited by a PCI-certified auditor and is certified
            to
            PCI Service Provider Level 1. We accept credit card payments through Stripe for all bookings. When a booking
            is
            confirmed for your listing, we will send you a quote to accept and payment will be sent to you online via
            Stripe, prior to the use of your space.</p> <br>
        <h3><strong>Final Step</strong></h3>
        <p> Listing your amazing space!</p>

    </div>`,
            data: this.account,
          })
          .then(() => {
            this.signup();
          })
          .catch(() => {});
      } else {
        this.signup();
      }
    },
    signup() {
      if (!this.loading) {
        this.errors = [];
        this.loading = true;

        axios
          .post("/api/auth/register", this.account)
          .then((response) => {
            // Save our user details
            this.$store.commit("user/token", response.data.token);
            this.$store.dispatch("user/setAuthHeader");
            this.$store.commit("user/authenticated", response.data.user);

            // Set first login/should complete profile (open welcome account panel view)
            this.$store.commit("user/setShouldCompleteProfile", true);

            // Populate some data for Intercom
            if (window.intercomSettings) {
              window.intercomSettings.user_id = response.data.user.id;
              window.intercomSettings.user_hash= response.data.user.intercom_user_hash;
              window.intercomSettings.email = response.data.user.email;
              window.intercomSettings.name = response.data.user.first_name + " " + response.data.user.last_name;
              window.intercomSettings.user_type = response.data.user.user_type;
              window.intercomSettings.job_title = response.data.user.job_title;
              window.intercomSettings.phone = response.data.user.phone;
              window.intercomSettings.created_at = response.data.user.created_at;

              if (window.Intercom) {
                window.Intercom("update", window.intercomSettings);
              }

              window.dataLayer.push({event: 'join-submit'});

              this.$store.dispatch("intercom/track", {
                type: "Join",
              });
              console.log('Intercom New: Join');
            }

            // Show our account panel
            this.$store.commit("user/dismissAuth");
            if (!this.inline) {
              this.$store.dispatch("account/commitMutation", {
                mutation: "open",
                data: true,
              });
            }

            // Reset account state
            Object.assign(this.account, this.accountState());

            this.$emit("signedUp", response);

            this.$toasted.show(
              `Thanks ${this.account.first_name}, we've sent you an email with next steps.`,
              {
                type: "success",
              }
            );
            this.loading = false;
          })
          .catch((error) => {
            if (
              typeof error.response !== "undefined" &&
              error.response.status === 422
            ) {
              this.$toasted.show(
                error.response.data.errors[
                  Object.keys(error.response.data.errors)[0]
                ],
                {
                  type: "error",
                }
              );
              this.loading = false;
              return (this.errors = error.response.data.errors);
            }
            this.$toasted.show(error.response.data, {
              type: "error",
            });
          });
        //   .then(() => {
        //     this.loading = false;
        //   });
      }
    },
    async onboard() {
      await axios
        .get("/api/account/stripe-connect/account/onboard", {
          params: {
            redirect_to: null,
          },
        })
        .then((response) => {
          if (response.data.url) {
            // Set first login/should complete profile (open welcome account panel view)
            this.$store.commit("user/dismissAuth");

            // Reset account state
            Object.assign(this.account, this.accountState());

            this.$emit("signedUp", response);

            this.$toasted.show(
              `Thanks ${this.account.first_name}, we've sent you an email with next steps.`,
              {
                type: "success",
              }
            );
            return (window.location.href = response.data.url);
          }
          throw new Error("Invalid onboard link response");
        })
        .catch(() => {
          this.$toasted.show("Could not fetch Stripe connect onboard link", {
            type: "error",
          });
          this.loading = false;
        });
    },

    handleTermsClick(e) {
      let handled = false;

      if (e.target.tagName === "A") {
        switch (e.target.pathname) {
          case "/terms-and-conditions":
            handled = this.showTermsModal(
              "Terms & Conditions",
              "terms-general"
            );
            break;
          case "/terms-and-conditions/hirer":
            handled = true;
            window.open("/pdf/hirer-agreement.pdf", '_blank');
            break;
          case "/terms-and-conditions/lister":
            handled = true;
            window.open("/pdf/lister-agreement.pdf", '_blank');
            break;
          case "/privacy-policy":
            handled = this.showTermsModal("Privacy Policy", "privacy-policy");
            break;
        }
      }

      if (handled) {
        e.preventDefault();
        e.stopPropagation();
      }
    },

    showTermsModal(title, which) {
      this.$store.dispatch("modals/show", { title: title, type: which });
      return true;
    },
  },
};
</script>
